import { action } from 'typesafe-actions';
import { DocActionTypes } from './types';
import { DocAccessType, IDocuments, IFinanceDocuments } from '../../../types';

// export const toggleRequiredDocs = (
//   sponsorType: string,
//   sponsorKey: string,
//   docType: string | null,
//   docKey: string | null,
//   reason?: string
// ) =>
//   action(DocActionTypes.TOGGLE_REQUIRED_DOCUMENTS, {
//     sponsorType,
//     sponsorKey,
//     docType,
//     docKey,
//     reason
//   });

export function approveDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  docStatus?: string,
  docPrevStatus?: string,
) {
  return action(DocActionTypes.APPROVE_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason: '',
    status: docStatus === 'APPROVED' && docPrevStatus ? docPrevStatus : 'APPROVED',
  });
}

export function acknowledgeDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  docStatus?: string,
  docPrevStatus?: string,
) {
  return action(DocActionTypes.ACKNOWLEDGE_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason: '',
    status: docStatus === 'ACKNOWLEDGED' && docPrevStatus ? docPrevStatus : 'ACKNOWLEDGED',
  });
}

export function toggleDocStatusSuccess({
  finDocs,
  complete,
  required,
}: {
  finDocs: IFinanceDocuments;
  complete: number;
  required: number;
}) {
  return action(DocActionTypes.TOGGLE_DOC_SUCCESS, { finDocs, complete, required });
}

export function toggleDocStatusFailure(error: unknown) {
  return action(DocActionTypes.TOGGLE_DOC_FAILURE, {
    error,
  });
}

export function rejectDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  status: IDocuments['status'],
  reason?: string,
  isCustomDocRequested?: boolean,
) {
  return action(DocActionTypes.REJECT_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason,
    status,
    isCustomDocRequested,
  });
}

export function rescindRejectDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  status: IDocuments['status'],
  reason?: string,
  isCustomDocRequested?: boolean,
) {
  return action(DocActionTypes.RESCIND_REJECT_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason,
    status,
    isCustomDocRequested,
  });
}

export function deleteDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  reason?: string,
) {
  return action(DocActionTypes.DELETE_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason,
    status: 'DELETED',
  });
}

export function requestCustomDoc(documentName: string, documentDescription: string, userAccess?: DocAccessType) {
  return action(DocActionTypes.CUSTOM_DOCUMENT_REQUEST, {
    documentName,
    documentDescription,
    userAccess,
  });
}
